import React from 'react';
import { Card } from 'reactstrap';
import { format } from 'date-fns';
import { PseudoStates, useFetch } from '@cordata/buffet';

import { MatchStatus } from '~/utils/const/identity';
import BigNumberCard from '~/components/common/BigNumberCard';

import usePatient from '~/utils/patient/hook';

const UpcomingAppts = () => {
  const [, patient] = usePatient();
  const [s, , meta] = useFetch('data/public/list-view-cs-tbl-appointments', {
    params: {
      sacwis_id: patient.sacwisPersonId,
      match_status_id: MatchStatus.Approved,
      'apptcategory__!': 'Missed',
      'appttime_ts__>>': format(new Date(), 'MM/DD/YYYY'),
    },
    instance: 'p',
  });

  return s === 'success'
    ? <BigNumberCard title="Upcoming Appointments" number={meta.total} />
    : <Card body><PseudoStates status={s} /></Card>;
};

export default UpcomingAppts;
